import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-[#0B0B0B] border-t border-white/10 text-white py-12 mt-auto" data-id="element-190">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-191">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-192">
          <div className="col-span-1 md:col-span-2" data-id="element-193">
            <div className="flex items-center gap-2 mb-4" data-id="element-194">
              <div className="w-8 h-8 bg-[#C9A34E] rounded-lg flex items-center justify-center" data-id="element-195">
                <span className="text-[#0B0B0B] font-bold text-lg leading-none" data-id="element-196">
                  N
                </span>
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-197">
                NOIZA
              </span>
            </div>
            <p className="text-white/40 max-w-sm mb-6" data-id="element-198">
              El marketplace gastronómico de Los Santos. Descubre, ordena y
              disfruta de los mejores restaurantes de la zona en un solo lugar.
            </p>
          </div>

          <div data-id="element-199">
            <h4 className="font-semibold text-white mb-4" data-id="element-200">Explorar</h4>
            <ul className="space-y-3" data-id="element-201">
              <li data-id="element-202">
                <Link to="/" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-203">
                  Inicio
                </Link>
              </li>
              <li data-id="element-204">
                <Link to="/restaurants" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-205">
                  Restaurantes
                </Link>
              </li>
              <li data-id="element-206">
                <Link to="/cart" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-207">
                  Carrito
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-208">
            <h4 className="font-semibold text-white mb-4" data-id="element-209">Para Restaurantes</h4>
            <ul className="space-y-3" data-id="element-210">
              <li data-id="element-211">
                <a href="#" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-212">
                  Únete a NOIZA
                </a>
              </li>
              <li data-id="element-213">
                <a href="#" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-214">
                  Portal de Socios
                </a>
              </li>
              <li data-id="element-215">
                <a href="#" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-216">
                  Soporte
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-217">
          <p className="text-white/30 text-sm" data-id="element-218">
            © {new Date().getFullYear()} NOIZA. Todos los derechos reservados.
            Los Santos, Costa Rica.
          </p>
          <div className="flex gap-4" data-id="element-219">
            <a href="#" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-220">
              Términos
            </a>
            <a href="#" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-221">
              Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}